import React from 'react';
import * as Styled from './MRating.styles';
import { MRatingProps } from './MRating.types';
import { MStarGroup } from '../MStarGroup';
import { ALabel } from '../../atoms/ALabel';
import { ATextInteractive } from '../../atoms/ATextInteractive';

const COMPONENT_NAME = 'm-web-ui-kit-MRating';
export const M_RATING_TEST_ID = 'web-ui-kit-MRating';

export const MRating: React.FC<MRatingProps> = ({
  singleStar = false,
  mStarGroup,
  aLabel,
  aTextInteractive,
  className,
  ...rest
}) => {
  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={M_RATING_TEST_ID}
      className={className}
      $singleStar={singleStar}
      {...rest}
    >
      <Styled.StarGroupWrapper>
        <MStarGroup {...mStarGroup} />
      </Styled.StarGroupWrapper>

      <Styled.LabelWrapper>
        <ALabel {...aLabel} />
      </Styled.LabelWrapper>

      <Styled.TextInteractiveWrapper>
        <ATextInteractive {...aTextInteractive} />
      </Styled.TextInteractiveWrapper>
    </Styled.Wrapper>
  );
};

export * from './MRating.types';
